import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import UnitMeasures from "../UnitMeasures";

export default function WorkLineForm({ state, handleInputChange, parameters, analisysTypes, handleSelectChange, submit, workLine, isEditing, isReadOnly, workLineType }) {
    const { t } = useTranslation()
    const [selectedParameter, setSelectedParameter] = useState(null)

    const addParameter = () => {
        if (selectedParameter) {
            const paramData = parameters?.find(param => param?._id === selectedParameter?.value)

            if (paramData) {
                const newParam = {
                    parameterReferenced: selectedParameter?.value,
                    parameter: paramData?._id,
                    parameterName: paramData?.name,
                    unitMeasure: paramData?.unitMeasure || "",
                    minValue: paramData?.minValue || 0,
                    maxValue: paramData?.maxValue || 0
                }

                const updatedParams = [...(workLine.params || []), newParam]

                handleInputChange({
                    target: {
                        name: 'params',
                        value: updatedParams
                    }
                })

                setSelectedParameter(null)
            }
        }
    }

    const removeParameter = (index) => {
        const updatedParams = workLine.params.filter((_, i) => i !== index);
        handleInputChange({
            target: {
                name: 'params',
                value: updatedParams
            }
        })
    }

    const updateParameter = (index, key, value) => {
        const updatedParams = workLine.params.map((param, i) =>
            i === index ? { ...param, [key]: key.includes("Value") ? Number(value) : value } : param
        )
        handleInputChange({
            target: {
                name: 'params',
                value: updatedParams
            }
        })
    }

    return (
        <Form onSubmit={e => e.preventDefault()} className="px-4 formulario">
            {!isReadOnly && (
                <>
                    <Row className="my-3">
                        {workLineType === "Análisis" ?
                            <Col>
                                <h5>{t('admin.workOrders.analisysType')}</h5>
                                <Select
                                    className="select"
                                    classNamePrefix="sd-select"
                                    options={analisysTypes?.map(type => ({ value: type.name, label: type.name }))}
                                    onChange={(selected) => handleSelectChange({ target: { name: "description", value: selected.value } })}
                                    value={workLine.description ? { value: workLine.description, label: workLine.description } : null}
                                    placeholder={t('admin.workOrders.selectAnalisysType')}
                                    isDisabled={isReadOnly}
                                />
                            </Col>
                            :
                            <Col>
                                <h5>{t("admin.budgets.workLineDescription")}</h5>
                                <Form.Control
                                    as="textarea"
                                    name="description"
                                    placeholder={t("admin.budgets.workLineDescription")}
                                    value={workLine.description || ""}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        }
                    </Row>
                    <Row className="my-3">
                        <Col>
                            <h5>{t("admin.budgets.price") + " (€)"}</h5>
                            <Form.Control
                                className="sd-input"
                                min={0}
                                type="number"
                                name="price"
                                placeholder={t("admin.budgets.price")}
                                value={workLine.price || 0}
                                onChange={handleInputChange}
                            />
                        </Col>

                        <Col>
                            <h5>{t("admin.budgets.recurrence")}</h5>
                            <Select
                                className="select"
                                classNamePrefix="sd-select"
                                options={[
                                    { value: "Sin recurrencia", label: "Sin recurrencia", default: true },
                                    { value: "Semanal", label: "Semanal" },
                                    { value: "Mensual", label: "Mensual" },
                                    { value: "Trimestral", label: "Trimestral" },
                                    { value: "Anual", label: "Anual" }
                                ]}
                                value={{ value: workLine.recurrence, label: workLine.recurrence }}
                                onChange={(selected) => handleInputChange({
                                    target: { name: "recurrence", value: selected.value }
                                })}
                            />
                        </Col>

                        {workLine.recurrence !== "Sin recurrencia" && (
                            <Col>
                                <h5>{t("admin.budgets.amountRecurrence")}</h5>
                                <Form.Control
                                    className="sd-input"
                                    min={1}
                                    type="number"
                                    name="amountRecurrence"
                                    placeholder={t("admin.budgets.amountRecurrence")}
                                    value={workLine.amountRecurrence || 0}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        )}
                    </Row>
                    {workLineType === "Análisis" && (
                        <Row className="my-3">
                            <Col xs={4}>
                                <h5>{t('admin.workOrders.analisysQuantity')}</h5>
                                <Form.Control
                                    className="sd-input"
                                    type='number'
                                    min={1}
                                    name='quantity'
                                    value={workLine.quantity || 0}
                                    onChange={handleInputChange}
                                    readOnly={isReadOnly}
                                />
                            </Col>
                            <Col xs={5}>
                                <h5>{t('admin.analisysTypes.parameters')}</h5>
                                <Select
                                    className="select"
                                    classNamePrefix="sd-select"
                                    options={parameters?.sort((a, b) => a.name.localeCompare(b.name)).map(param => ({ value: param._id, label: param.name }))}
                                    onChange={setSelectedParameter}
                                    value={selectedParameter}
                                    placeholder={t('admin.analisysTypes.selectParameter')}
                                    isDisabled={isReadOnly}
                                />
                            </Col>
                            <Col xs={3} className="align-self-end">
                                <Button variant="fourth" onClick={addParameter}>{t('admin.analisysTypes.addParameter')}</Button>
                            </Col>
                        </Row>
                    )}
                </>
            )}
            {
                workLine.params?.length > 0 && workLine?.params?.map((param, index) => (
                    < Row key={index} className="mb-2 border rounded p-2" >
                        <Col xs={12}>
                            <Row>
                                <Col xs={6} md={5}>
                                    <div className="d-flex align-items-center">
                                        {!isReadOnly && (
                                            <Button variant="third" onClick={() => removeParameter(index)}>
                                                <i className="fas fa-trash"></i>
                                            </Button>
                                        )}
                                        <Form.Control
                                            className="sd-input"
                                            type='text'
                                            value={param.parameterName || parameters?.find(p => p._id === param?.parameter)?.name}
                                            readOnly
                                        />
                                    </div>
                                </Col>
                                <Col xs={6} md={2}>
                                    <Form.Control
                                        className="sd-input"
                                        type='number'
                                        step="any"
                                        placeholder={t('admin.parameters.minValue')}
                                        value={param.minValue}
                                        onChange={(e) => updateParameter(index, 'minValue', e.target.value)}
                                        readOnly={isReadOnly}
                                    />
                                </Col>
                                <Col xs={6} md={2}>
                                    <Form.Control
                                        className="sd-input"
                                        type='number'
                                        step="any"
                                        placeholder={t('admin.parameters.maxValue')}
                                        value={param.maxValue}
                                        onChange={(e) => updateParameter(index, 'maxValue', e.target.value)}
                                        readOnly={isReadOnly}
                                    />
                                </Col>
                                <Col xs={6} md={3}>
                                    <UnitMeasures
                                        onChange={(selected) => updateParameter(index, 'unitMeasure', selected?.value)}
                                        value={param.unitMeasure ? { value: param.unitMeasure, label: t(param.unitMeasure) } : null}
                                        isReadOnly={isReadOnly}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                ))
            }
            {!isReadOnly && (
                <Button variant="primary" onClick={submit}>
                    {isEditing ? t('admin.workOrders.updateWorkLine') : t('admin.workOrders.saveWorkLine')}
                </Button>
            )}
        </Form >
    );
} 